/**
 * 单点登录接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SingleSignonConfigService {
  //基础平台微服务api
  prefix: string = environment.seekerWebAPI;

  constructor(
    private http: SwHttpClientService,
    private httpClient: HttpClient,
  ) {
  }

  //#region 
  /**
   * 分页查询
   * @param param
   * @returns {Observable<any>}
   */
  queryPageList(param) {
    const url = this.prefix + 'swSsoSystem/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 根据ID查询
   * @param param
   * @returns {Observable<any>}
   */
  queryById(param) {
    const url = this.prefix + 'swSsoSystem/getById/' + param.id;
    return this.http.Get(url);
  }


  /**
* 新增
* @param param
* @returns {Observable<any>}
*/
  save(param) {
    const url = this.prefix + 'swSsoSystem/save';
    return this.http.Post(url, param);
  }

  /**
   * 更新
   * @param param
   * @returns {Observable<any>}
   */
  updateById(param) {
    const url = this.prefix + 'swSsoSystem/updateById';
    return this.http.Post(url, param);
  }

  /**
* 批量同步组织或用户
* @param param
* @returns {Observable<any>}
*/
  saveBatch(param) {
    const url = this.prefix + 'swSsoSync/saveBatch';
    return this.http.Post(url, param);
  }

  /**
   * 查询已同步数据
   * @param param
   * @returns {Observable<any>}
   */
  queryOrgUserList(param) {
    const url = this.prefix + 'swSsoSync/queryPageList';
    return this.http.Post(url, param);
  }


  //常用资料接口

  /**
   * 查询常用资料列表
   * @param param
   * @returns {Observable<any>}
   */
  querySysImportantInfo(param) {
    const url = this.prefix + 'swSysImportantInfo/queryPageList';
    return this.http.Post(url, param);
  }

  /**
 * 新增常用资料列表
 * @param param
 * @returns {Observable<any>}
 */
  saveSysImportantInfo(param) {
    const url = this.prefix + 'swSysImportantInfo/save';
    return this.http.Post(url, param);
  }

  /**
* 修改常用资料列表
* @param param
* @returns {Observable<any>}
*/
  updateSysImportantInfo(param) {
    const url = this.prefix + 'swSysImportantInfo/updateById';
    return this.http.Post(url, param);
  }

  /**
 * 删除常用资料列表
 * @param param
 * @returns {Observable<any>}
 */
  deleteSysImportantInfo(param) {
    const url = this.prefix + 'swSysImportantInfo/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
* 根据id查询常用资料列表
* @param param
* @returns {Observable<any>}
*/
  getByIdSysImportantInfo(param) {
    const url = this.prefix + 'swSysImportantInfo/getById/' + param;
    return this.http.Post(url, {});
  }
}
